var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "col-md-12" }, [
      _c("div", { staticClass: "col-md-3" }, [
        _c("div", { staticClass: "form-group" }, [
          _c("label", [_vm._v("Km por Litro")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.km_litro,
                expression: "km_litro"
              },
              {
                name: "mask",
                rawName: "v-mask",
                value: ["##", "#"],
                expression: "['##','#']"
              }
            ],
            staticClass: "form-control",
            attrs: { type: "text" },
            domProps: { value: _vm.km_litro },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.km_litro = $event.target.value
              }
            }
          })
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-md-3" }, [
        _c("div", { staticClass: "form-group" }, [
          _c("label", [_vm._v("Km por Dia ")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.km_dia,
                expression: "km_dia"
              },
              {
                name: "mask",
                rawName: "v-mask",
                value: ["##", "###", "####"],
                expression: "['##','###','####']"
              }
            ],
            staticClass: "form-control",
            attrs: { type: "text" },
            domProps: { value: _vm.km_dia },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.km_dia = $event.target.value
              }
            }
          })
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-md-3" }, [
        _c("div", { staticClass: "form-group" }, [
          _c("label", [_vm._v("Valor Médio de Hospedagem")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.valor_hospedagem,
                expression: "valor_hospedagem"
              },
              {
                name: "mask",
                rawName: "v-mask",
                value: ["#,##", "##,##", "###,##"],
                expression: "['#,##','##,##','###,##']"
              }
            ],
            staticClass: "form-control",
            attrs: { type: "text" },
            domProps: { value: _vm.valor_hospedagem },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.valor_hospedagem = $event.target.value
              }
            }
          })
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "col-md-12" }, [
      _c("div", { staticClass: "col-md-3" }, [
        _c("div", { staticClass: "form-group" }, [
          _c("label", [_vm._v("Valor Médio de alimentação por dia")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.valor_alimentacao,
                expression: "valor_alimentacao"
              },
              {
                name: "mask",
                rawName: "v-mask",
                value: ["#,##", "##,##"],
                expression: "['#,##','##,##']"
              }
            ],
            staticClass: "form-control",
            attrs: { type: "text" },
            domProps: { value: _vm.valor_alimentacao },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.valor_alimentacao = $event.target.value
              }
            }
          })
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-md-3" }, [
        _c("div", { staticClass: "form-group" }, [
          _c("label", [_vm._v("Valor médio do Combustível")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.valor_combustivel,
                expression: "valor_combustivel"
              },
              {
                name: "mask",
                rawName: "v-mask",
                value: ["#,##", "##,##"],
                expression: "['#,##','##,##']"
              }
            ],
            staticClass: "form-control",
            attrs: { type: "text" },
            domProps: { value: _vm.valor_combustivel },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.valor_combustivel = $event.target.value
              }
            }
          })
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-md-3" }, [
        _c("div", { staticClass: "form-group" }, [
          _c("label", [_vm._v("Km Extra")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.km_extra,
                expression: "km_extra"
              },
              {
                name: "mask",
                rawName: "v-mask",
                value: ["###"],
                expression: "['###']"
              }
            ],
            staticClass: "form-control",
            attrs: { type: "text" },
            domProps: { value: _vm.km_extra },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.km_extra = $event.target.value
              }
            }
          })
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-md-12" }, [
        _c(
          "button",
          { staticClass: "btn btn-primary", on: { click: _vm.saveParametro } },
          [_vm._v("Salvar Parametros")]
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0c765bd2", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0c765bd2","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/rotas/Parametros.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-0c765bd2","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/rotas/Parametros.vue
// module chunks = 2